import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL } from "../../config/config";


export const ElectricBill = createAsyncThunk(
  "bill/electric",
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      let response;

      if (id) {
        // 🔵 Tenant side (Update)
        response = await axios.post(
          `${BASE_URL}/update-electric-reading/${id}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        // 🟢 Owner side (Create)
        response = await axios.post(
          `${BASE_URL}/electric-reading`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);





const ElectricReading = createSlice({
  name: "electricReading",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(ElectricBill.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ElectricBill.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(ElectricBill.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default ElectricReading.reducer;